import React, {useMemo} from "react";
import {useNavigate} from "react-router-dom";
import ChartLoadingOverlay from "../../components/Utils/ChartLoadingOverlay";
import {addHeaderTab, openHeaderTabWithChild} from "../../components/pageTabs/pageTabsStorage";

const NOTICE_LIST_PATH = "/settings/noticelist/main";
const NOTICE_LIST_TITLE = "공지사항";
const MAX_VISIBLE = 5;

const formatNoticeDate = (createdAt) => {
    if (!createdAt) return "";
    if (typeof createdAt === "string") {
        return createdAt.length >= 10 ? createdAt.substring(0, 10) : createdAt;
    }
    return "";
};

function NoticeCard({item, onSelect}) {
    const title = item?.subject ?? "";

    return (
        <button
            type="button"
            onClick={onSelect}
            className="flex min-w-0 flex-col items-start rounded-lg border border-[#e5e7eb] bg-white px-4 py-3 text-left transition-colors hover:border-[#cbd5e1] md:h-full md:flex-1"
        >
            <p className="line-clamp-2 w-full flex-1 text-[14px] leading-snug text-[#111827]">
                {title}
            </p>
            <p className="mt-auto shrink-0 pt-2 text-[13px] text-[#9ca3af]">
                {formatNoticeDate(item?.createdAt)}
            </p>
        </button>
    );
}

function TotalNoticeContent({items}) {
    const navigate = useNavigate();

    const visibleItems = useMemo(() => items.slice(0, MAX_VISIBLE), [items]);

    const handleCardClick = (item) => {
        if (item?.link && item?.id != null) {
            const detailUrl = `${item.link}/${item.id}`;
            openHeaderTabWithChild({
                header: {
                    title: NOTICE_LIST_TITLE,
                    url: NOTICE_LIST_PATH,
                    icon: "setting",
                },
                child: {
                    title: item.subject || NOTICE_LIST_TITLE,
                    url: detailUrl,
                },
            });
            navigate(detailUrl);
        }
    };

    return (
        <div className="total-notice flex h-full min-h-0 flex-col bg-white">
            <div className="mb-3 flex shrink-0 items-center justify-between gap-2">
                <h3 className="text-[21px] font-bold leading-none text-[#111827]">공지사항</h3>
                <button
                    type="button"
                    onClick={() => {
                        addHeaderTab({
                            title: NOTICE_LIST_TITLE,
                            url: NOTICE_LIST_PATH,
                            icon: "setting",
                        });
                        navigate(NOTICE_LIST_PATH);
                    }}
                    className="shrink-0 text-[13px] text-[#9ca3af] transition-colors hover:text-[#6b7280]"
                >
                    더보기 &gt;
                </button>
            </div>

            {visibleItems.length > 0 ? (
                <div className="flex min-h-0 flex-1 flex-col items-stretch gap-3 md:flex-row">
                    {visibleItems.map((item, index) => (
                        <NoticeCard
                            key={item.id ?? index}
                            item={item}
                            onSelect={() => handleCardClick(item)}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex flex-1 items-center justify-center text-[13px] text-[#9ca3af]">
                    No Data.
                </div>
            )}
        </div>
    );
}

export function TotalNotice({data, loading = false}) {
    const items = Array.isArray(data) ? data : [];

    if (!items.length && loading) {
        return (
            <div className="total-notice relative flex h-full min-h-0 flex-col bg-white">
                <h3 className="shrink-0 text-[16px] font-bold leading-none text-[#111827]">공지사항</h3>
                <ChartLoadingOverlay />
            </div>
        );
    }

    return (
        <div className="relative flex h-full min-h-0 flex-col">
            {loading && <ChartLoadingOverlay />}
            <TotalNoticeContent items={items} />
        </div>
    );
}

export default TotalNotice;
